/* Exporting patient care path service default object. */
export default {
  carePathServices: [],
  carePathServicesList: [],
};
